import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

type AlertType = 'error' | 'warning' | 'success' | 'info';

@Component({
  selector: 'app-base-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './base-alert.component.html',
  styleUrls: ['./base-alert.component.scss'],
})
export class BaseAlertComponent {
  @Input() type: AlertType = 'error';
  @Input() title = '';
  @Input() message = '';
  @Input() closeable = true;
  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }

  get bgColor(): string {
    const colors = {
      error: 'bg-red-50',
      warning: 'bg-yellow-50',
      success: 'bg-green-50',
      info: 'bg-blue-50',
    };
    return colors[this.type];
  }

  get borderColor(): string {
    const colors = {
      error: 'border-red-300',
      warning: 'border-yellow-300',
      success: 'border-green-300',
      info: 'border-blue-300',
    };
    return colors[this.type];
  }

  get titleColor(): string {
    const colors = {
      error: 'text-red-800',
      warning: 'text-yellow-800',
      success: 'text-green-800',
      info: 'text-blue-800',
    };
    return colors[this.type];
  }

  get messageColor(): string {
    const colors = {
      error: 'text-red-700',
      warning: 'text-yellow-700',
      success: 'text-green-700',
      info: 'text-blue-700',
    };
    return colors[this.type];
  }
}
